import React from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField } from "@mui/material";

interface DiscardProjectLeadDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (reason: string) => Promise<void> | void;
  projectName: string;
}

/** Dialog for "Lead verwerfen". HoCR-only; Begründung is mandatory. */
const DiscardProjectLeadDialog = ({ open, onClose, onConfirm, projectName }: DiscardProjectLeadDialogProps) => {
  const [reason, setReason] = React.useState("");
  const [error, setError] = React.useState(false);
  const [submitting, setSubmitting] = React.useState(false);

  // Reset state whenever the dialog is re-opened
  React.useEffect(() => {
    if (open) {
      setReason("");
      setError(false);
    }
  }, [open]);

  const handleConfirm = async () => {
    if (reason.trim().length === 0) {
      setError(true);
      return;
    }
    try {
      setSubmitting(true);
      await onConfirm(reason.trim());
      onClose();
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Lead „{projectName}“ verwerfen?</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ mb: 2 }}>
          Der Lead-Status wird auf „Lead verworfen“ gesetzt. Eine Begründung ist verpflichtend.
        </DialogContentText>
        <TextField
          autoFocus
          label="Begründung"
          required
          fullWidth
          multiline
          minRows={3}
          value={reason}
          onChange={(e) => {
            setReason(e.target.value);
            if (e.target.value.trim().length > 0) setError(false);
          }}
          error={error}
          helperText={error ? "Begründung ist erforderlich" : undefined}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={submitting}>
          Abbrechen
        </Button>
        <Button onClick={handleConfirm} color="error" variant="contained" disabled={submitting}>
          Verwerfen
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DiscardProjectLeadDialog;
